import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
  MaterialButtonThumbnail,
  MaterialButtonEditIcon,
  MaterialButtonContainer,
  MaterialButtonName,
} from './styled';

export class MaterialButton extends PureComponent {
  static propTypes = {
    imageUrl: PropTypes.string.isRequired,
    handleClick: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    colorHex: PropTypes.string.isRequired,
  };

  render() {
    const { colorHex, handleClick, id, imageUrl, name } = this.props;

    return (
      <MaterialButtonContainer
        onClick={() => handleClick(id)}
        data-selenium="materialButton"
      >
        <MaterialButtonThumbnail url={imageUrl} color={colorHex}>
          <MaterialButtonEditIcon src={require('src/assets/images/edit.svg')} />
        </MaterialButtonThumbnail>
        <MaterialButtonName data-selenium="materialNameText">
          {name}
        </MaterialButtonName>
      </MaterialButtonContainer>
    );
  }
}

export default MaterialButton;
